import type { ReactNode } from "react";
import type { ReportDetailField } from "../../data/types";
import { RapportkatalogCardDescription } from "./RapportkatalogCardDescription";
import { RapportkatalogCardDetails } from "./RapportkatalogCardDetails";
import "./RapportkatalogCardDescriptionAndDetails.css";

type RapportkatalogCardDescriptionAndDetailsProps = {
    description: string;
    detailFields: ReportDetailField[];
    renderDetailValue: (value: string, label?: string) => ReactNode;
};

export function RapportkatalogCardDescriptionAndDetails({
    description,
    detailFields,
    renderDetailValue,
}: RapportkatalogCardDescriptionAndDetailsProps) {
    return (
        <div className="rapportkatalog-card-description-and-details">
            <RapportkatalogCardDescription text={description} />
            <RapportkatalogCardDetails detailFields={detailFields} renderDetailValue={renderDetailValue} />
        </div>
    );
}
